import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import styles from "./wrappedDailySnapshot.module.css";

function SnapshotMetricPlaceholder() {
  return (
    <div className={styles.metricContainerPlaceholder}>
      <Placeholder.Line />
    </div>
  );
}

export function WrappedDailySnapshotPlaceholder() {
  return (
    <div className={styles.snapshot}>
      <div className={styles.snapshotTitle}>Daily Snapshot</div>
      <div className={styles.snapshotGrid}>
        <div className={styles.snapshotGridRow}>
          <SnapshotMetricPlaceholder />
          <SnapshotMetricPlaceholder />
        </div>
        <div className={styles.snapshotGridRow}>
          <SnapshotMetricPlaceholder />
          <SnapshotMetricPlaceholder />
        </div>
      </div>
    </div>
  );
}
